// @ts-nocheck
(function () {
  const DRAWER_SELECTOR = '[data-sonno-drawer]';
  const TEMPLATE_SELECTOR = '[data-sonno-drawer-template]';
  const TRIGGER_SELECTOR = '[data-sonno-drawer-trigger]';

  function escapeAttr(value) {
    const raw = String(value || '');
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(raw);
    }
    return raw.replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  }

  function lockScroll(locked) {
    if (locked) {
      document.documentElement.classList.add('sonno-dimensions-lock');
    } else {
      document.documentElement.classList.remove('sonno-dimensions-lock');
    }
  }

  function closeDrawer(drawerEl) {
    if (!drawerEl) return;

    const returnTo = drawerEl.getAttribute('data-sonno-drawer-return-to') || '';
    drawerEl.classList.remove('is-open');
    drawerEl.setAttribute('aria-hidden', 'true');

    if (document.querySelector(`${DRAWER_SELECTOR}.is-open`)) return;
    lockScroll(false);

    // Nested drawer support: when a drawer is closed and it declares a parent drawer id,
    // restore the parent drawer (if any).
    if (returnTo) {
      const parentDrawer = findOrCreateDrawer(returnTo);
      if (!parentDrawer) return;
      bindCloseHandlers(parentDrawer);
      requestAnimationFrame(() => openDrawer(parentDrawer));
    }
  }

  function openDrawer(drawerEl) {
    if (!drawerEl) return;

    document.querySelectorAll(`${DRAWER_SELECTOR}.is-open`).forEach((openEl) => {
      if (openEl !== drawerEl) closeDrawer(openEl);
    });

    drawerEl.classList.add('is-open');
    drawerEl.setAttribute('aria-hidden', 'false');
    lockScroll(true);

    window.dispatchEvent(
      new CustomEvent('sonno:drawerOpened', {
        detail: { drawerId: drawerEl.getAttribute('data-drawer-id') || '' },
      })
    );
  }

  function bindCloseHandlers(drawerEl) {
    if (!drawerEl || drawerEl.getAttribute('data-sonno-drawer-bound') === '1') return;
    drawerEl.setAttribute('data-sonno-drawer-bound', '1');

    drawerEl.querySelectorAll('[data-sonno-drawer-close]').forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        closeDrawer(drawerEl);
      });
    });
  }

  function findOrCreateDrawer(drawerId) {
    if (!drawerId) return null;

    const escapedId = escapeAttr(drawerId);

    const existing = document.querySelector(`${DRAWER_SELECTOR}[data-drawer-id="${escapedId}"]`);
    if (existing) return existing;

    const tpl = document.querySelector(`${TEMPLATE_SELECTOR}[data-drawer-id="${escapedId}"]`);
    if (!tpl) return null;

    const fragment = tpl.content.cloneNode(true);
    const container = document.createElement('div');
    container.appendChild(fragment);

    const created = container.querySelector(`${DRAWER_SELECTOR}[data-drawer-id="${escapedId}"]`);
    if (!created) return null;

    document.body.appendChild(created);
    created.setAttribute('data-sonno-drawer-just-created', '1');
    return created;
  }

  function onTriggerClick(e) {
    const trigger = e.target && e.target.closest ? e.target.closest(TRIGGER_SELECTOR) : null;
    if (!trigger) return;

    const drawerId = trigger.getAttribute('data-sonno-drawer-id') || '';
    const drawerEl = findOrCreateDrawer(drawerId);
    if (!drawerEl) return;

    const returnTo = trigger.getAttribute('data-sonno-drawer-return-to') || '';
    if (returnTo) {
      drawerEl.setAttribute('data-sonno-drawer-return-to', returnTo);
    } else {
      drawerEl.removeAttribute('data-sonno-drawer-return-to');
    }

    bindCloseHandlers(drawerEl);

    // If this drawer was lazily injected from a <template>, allow one frame
    // so CSS can apply the initial transform before opening (enables transition).
    if (drawerEl.getAttribute('data-sonno-drawer-just-created') === '1') {
      drawerEl.removeAttribute('data-sonno-drawer-just-created');
      // Force style calculation
      // eslint-disable-next-line no-unused-expressions
      drawerEl.offsetHeight;
      requestAnimationFrame(() => openDrawer(drawerEl));
    } else {
      openDrawer(drawerEl);
    }

    e.preventDefault();
  }

  function onKeyDown(e) {
    if (e.key !== 'Escape') return;
    const openEl = document.querySelector(`${DRAWER_SELECTOR}.is-open`);
    if (openEl) closeDrawer(openEl);
  }

  function init() {
    document.addEventListener('click', onTriggerClick);
    document.addEventListener('keydown', onKeyDown);

    // Bind any drawers already in DOM
    document.querySelectorAll(DRAWER_SELECTOR).forEach(bindCloseHandlers);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
